/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AaiSecurityScheme } from '../../asyncapi/models/AaiSecurityScheme';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20NodeFactory } from '../../asyncapi/v2/models/Aai20NodeFactory';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { SecurityScheme } from '../../core/models/common/SecurityScheme';
import { NewSecuritySchemeCommand } from './NewSecuritySchemeCommand';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { Aai20Components } from '../../asyncapi/v2/models/Aai20Components';
import { Node } from '../../core/models/Node';

/**
 * A command used to create a new security scheme in an aaidocument.
 * @author c.desc2@gmail.com
 * @extends NewSecuritySchemeCommand
 * @class
 */
export class NewSecuritySchemeCommand_Aai20 extends NewSecuritySchemeCommand {
    public _nullComponents : boolean;

    public constructor(scheme? : any) {
        if(((scheme != null && scheme instanceof <any>SecurityScheme) || scheme === null)) {
            let __args = arguments;
            super(scheme);
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else if(scheme === undefined) {
            let __args = arguments;
            super();
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[NewSecuritySchemeCommand_Aai20] Executing.");
        let aai20Document : Aai20Document = <Aai20Document>document;
        this._nullComponents = false;
        if(this.isNullOrUndefined(aai20Document.components)) {
            aai20Document.components = aai20Document.createComponents();
            this._nullComponents = true;
        }
        if(this.isNullOrUndefined(aai20Document.components.getSecurityScheme(this._schemeName))) {
            let scheme : AaiSecurityScheme = new Aai20NodeFactory().createSecurityScheme(aai20Document.components, this._schemeName);
            Library.readNode(this._scheme, scheme);
            aai20Document.components.addSecurityScheme(this._schemeName, scheme);
            this._schemeExisted = false;
        } else {
            this._schemeExisted = true;
        }
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[NewSecuritySchemeCommand_Aai20] Reverting.");
        if(this._schemeExisted) {
            return;
        }
        let aai20Document : Aai20Document = <Aai20Document>document;
        if(this._nullComponents) {
            aai20Document.components = null;
            return;
        }
        aai20Document.components.removeSecurityScheme(this._schemeName);
    }
}
NewSecuritySchemeCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.NewSecuritySchemeCommand_Aai20";
NewSecuritySchemeCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




